<template>
  <div class="component-level">
    <label
      class="checkbox"
      v-for="level of levels" :key="level.code"
    >
      <input type="checkbox"
        v-model="selected" :value="level"
      />
      {{ level.code }}
    </label>
  </div>
</template>

<script lang="ts">
import { Level } from '@/store/master/types'
import { RootState } from '@/store/types'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class LevelsInput extends Vue {
  @Prop() value!: Level[]

  created() {
    this.$store.dispatch('fetchMasterLevels')
  }

  private get levels(): Level[] {
    return (this.$store.state as RootState).master.levels
  }

  private get selected(): Level[] {
    return this.value
  }

  private set selected(levels: Level[]) {
    this.$emit('input', levels)
  }
}
</script>

<style scoped>
input[type="checkbox"] {
  margin-right:8px;
}

.component-level {
  display:flex;
  flex-wrap: wrap;
}

.checkbox {
  display: block;
  width: 65px;
}
</style>
